import { createContext } from 'react';
var CollectionItemContext = /*#__PURE__*/createContext(undefined);
export { CollectionItemContext as C };